module.exports = "/_next/static/images/2725bc5362c6945118920dbf10e82ef7-WhereCanISeeIt.png";